import React from "react";
import { useTranslation } from "react-i18next";
import "./ServiceFinder.css";

const ServiceFinder = ({ activeSpec, setActiveSpec }) => {
  const { t } = useTranslation();

  const categories = [
    { id: 1, name: "Lifestyle", count: "2,300+ businesses", color: "#8b5cf6", icon: "✨" },
    { id: 2, name: "Financial & Legal", count: "1,800+ businesses", color: "#06b6d4", icon: "💼" },
    { id: 3, name: "Consulting", count: "1,500+ businesses", color: "#22c55e", icon: "🧭" },
    { id: 4, name: "Education & Training", count: "1,200+ businesses", color: "#2563eb", icon: "🎓" },
    { id: 5, name: "Marketing & Growth", count: "900+ businesses", color: "#f97316", icon: "📈" },
  ];

  return (
    <section className="wc-category-section">
      <div className="wc-category-container">
        {/* Title */}
        <h2 className="wc-category-title">{t("Explore by Category")}</h2>
        <p className="wc-category-subtitle">
          {t("Find trusted women-led businesses across various sectors")}
        </p>

        {/* Category Grid */}
        <div className="wc-category-grid">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`wc-category-card ${
                activeSpec === cat.id ? "active" : ""
              }`}
              onClick={() => setActiveSpec(cat.id)}
            >
              <div
                className="wc-category-icon"
                style={{
                  background: `linear-gradient(135deg, ${cat.color}33, ${cat.color}55)`,
                  color: cat.color,
                }}
              >
                {cat.icon}
              </div>
              <h3 className="wc-category-name">{cat.name}</h3>
              <p className="wc-category-count">{cat.count}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFinder;
